// libs
import { SubmissionError } from 'redux-form'
// utils
import { handleError } from 'utils/errors/handlers'
import { getUserMessage, normalizeError } from 'utils/errors/normalize'

// Turns anything thrown inside a redux-form submit handler into a form-level error (`error` prop).
// The backend does not send per-field errors, so everything goes to `_error`.
export const toSubmissionError = (error: unknown): SubmissionError => {
  handleError(error, 'Form submit')

  return new SubmissionError({ _error: getUserMessage(normalizeError(error)) })
}
